export const GET_CONFIG_CONRRESPONDENCE = 'GET_CONFIG_CONRRESPONDENCE';
export const MODIFY_CONFIG_CONRRESPONDENCE = 'MODIFY_CONFIG_CONRRESPONDENCE';
export const CREATE_CONFIG_CONRRESPONDENCE = 'CREATE_CONFIG_CONRRESPONDENCE';